const actions = {
    SET_DATA: 'workspaces/SET_DATA',
    GET_DATA: 'workspaces/GET_DATA',

    SET_WORKSPACE_DETAILS: 'workspace/SET_WORKSPACE_DETAILS',
    GET_WORKSPACE_DETAILS: 'workspace/GET_WORKSPACE_DETAILS',

    GET_WORKSPACES_TO_ALLOCATE: 'workspace/GET_WORKSPACES_TO_ALLOCATE',
    SET_WORKSPACES_TO_ALLOCATE: 'workspace/SET_WORKSPACES_TO_ALLOCATE',

    GET_INVITED_TO_WORKSPACE: "/workspace/GET_INVITED_TO_WORKSPACE",
    SET_INVITED_TO_WORKSPACE: "/workspace/SET_INVITED_TO_WORKSPACE",

    SET_INITIAL_WORKSPACE_COMBINED_DATA: 'workspace/SET_INITIAL_WORKSPACE_COMBINED_DATA'
};

export default actions
